import { render, staticRenderFns } from "./CDNSecondPer.vue?vue&type=template&id=03a1a70c&scoped=true&"
import script from "./CDNSecondPer.vue?vue&type=script&lang=js&"
export * from "./CDNSecondPer.vue?vue&type=script&lang=js&"
import style0 from "./CDNSecondPer.vue?vue&type=style&index=0&id=03a1a70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1a70c",
  null
  
)

export default component.exports